import axios from "axios";
import { API_URL_COMPANION } from "../apiURLS";

export interface ExtractedCandidate {
  content: string;
  sourceLine: string;
}

const scanTaskList = async (file: File): Promise<ExtractedCandidate[]> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const formData = new FormData();
  formData.append("image", file);

  const response = await axios.post<{ candidates: ExtractedCandidate[] }>(
    `${API_URL_COMPANION}/scan-task-list`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      withCredentials: true,
    },
  );

  if (response?.data?.candidates) return response.data.candidates;
  throw new Error("No data received.");
};

const dictateTasks = async (file: File): Promise<string[]> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const formData = new FormData();
  formData.append("audio", file);

  const response = await axios.post(
    `${API_URL_COMPANION}/dictate-tasks`,
    formData,
    {
      headers: { Authorization: `Bearer ${authToken}` },
      withCredentials: true,
    },
  );
  if (response?.data) return response.data;
  throw new Error("No data received.");
};

const transcribeAudio = async (file: File): Promise<{ text: string }> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const formData = new FormData();
  formData.append("audio", file);

  const response = await axios.post<{ text: string }>(
    `${API_URL_COMPANION}/transcribe`,
    formData,
    {
      headers: { Authorization: `Bearer ${authToken}` },
      withCredentials: true,
    },
  );
  if (response?.data) return response.data;
  throw new Error("No data received.");
};

const companionService = { scanTaskList, transcribeAudio, dictateTasks };
export default companionService;
